// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileEmptyState-cls1___09f3bc76959095f6b87","cls2":"ProfileEmptyState-cls2___621f54bf06c1f066816 ProfileEmptyState-cls1___09f3bc76959095f6b87"};